import { ticketColumns, ticketData } from '../../../Data/Support/TicketHistory';
import React, { Fragment} from 'react';
import CommonDataTable from '../../Common/Component/CommonDataTable';
import { Row ,Col} from 'reactstrap';

const TicketTable = () => {
    const processData=ticketData.map((element,index)=>{
        return {
            booking_number:element.booking_number,
            ticket_number:element.ticket_number,
            customer_name:element.customer_name,
            subject:element.subject,
            status:element.status,
            priority:element.priority,
            recent_activity:element.recent_activity,
            reported_on:element.reported_on,
            action:<Row>
            <Col xs="12" className='table-actions'>
                <span>
                <i className="icofont icofont-edit-alt"></i>
                </span>
                <span>
                <i className="fa fa-times-circle"></i>
                </span>
            </Col>
        </Row>
        }
    })
    return (
        <Fragment>
            <div className="table-responsive ticket-table">
                <CommonDataTable options={{
                    columns:ticketColumns,
                    data:processData,
                    center:true
                }}
                />
            </div>
        </Fragment>
    );
};
export default TicketTable;